import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_30517",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_30517)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask1_2938_30517",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: -3,
			y: -3,
			width: 105,
			height: 105,
			children: /* @__PURE__ */ _jsx("rect", {
				x: -3,
				y: -3,
				width: 105,
				height: 105,
				fill: "#C4C4C4"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask1_2938_30517)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.6027 66.1711C37.6019 66.1711 27.8097 62.9316 27.0736 58.8086H27V73.3901C27 77.7339 37.0867 81.2679 49.6029 81.2679C62.1191 81.2679 72.2057 77.7339 72.2057 73.3901V58.8086H72.1322C71.3957 62.9316 61.6036 66.1711 49.6027 66.1711Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.6029 66.1712C61.6037 66.1712 71.3959 62.9317 72.132 58.8087C72.2056 58.6615 72.2056 58.4406 72.2056 58.2934C72.2057 53.9496 62.1191 50.4155 49.6029 50.4155C37.0867 50.4155 27 53.9496 27 58.2934C27 58.4406 27 58.6615 27.0736 58.8087C27.8099 62.9317 37.602 66.1712 49.6029 66.1712Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.6027 51.7556C37.6019 51.7556 27.8097 48.516 27.0736 44.3931H27V58.9745C27 63.3183 37.0867 66.8524 49.6029 66.8524C62.1191 66.8524 72.2057 63.3183 72.2057 58.9745V44.3931H72.1322C71.3957 48.516 61.6036 51.7556 49.6027 51.7556Z",
					fill: "#F6DCC4",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.6029 51.7557C61.6037 51.7557 71.3959 48.5162 72.132 44.3932C72.2056 44.2459 72.2056 44.0251 72.2056 43.8779C72.2057 39.5341 62.1191 36 49.6029 36C37.0867 36 27 39.5341 27 43.8779C27 44.0251 27 44.2459 27.0736 44.3932C27.8099 48.5162 37.602 51.7557 49.6029 51.7557Z",
					fill: "#F6DCC4",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M48.8672 8.5C49.9832 8.50008 51.083 8.76747 52.0742 9.28027C53.0656 9.79326 53.9197 10.537 54.5645 11.4482C55.2092 12.3594 55.6264 13.412 55.7803 14.5176C55.918 15.5073 55.8397 16.5135 55.5557 17.4688H51.0967C51.3199 17.2191 51.5023 16.9338 51.6318 16.6211C51.8584 16.0742 51.9182 15.4722 51.8027 14.8916C51.6873 14.3111 51.4019 13.778 50.9834 13.3594C50.5648 12.9408 50.0308 12.6555 49.4502 12.54C48.8698 12.4247 48.2684 12.4836 47.7217 12.71C47.1747 12.9365 46.7068 13.3203 46.3779 13.8125C46.049 14.3048 45.873 14.8836 45.873 15.4756C45.8731 16.2138 46.149 16.9214 46.6387 17.4688H42.1777C41.8937 16.5135 41.8154 15.5073 41.9531 14.5176C42.107 13.412 42.5242 12.3594 43.1689 11.4482C43.8137 10.537 44.6678 9.79326 45.6592 9.28027C46.6505 8.76739 47.751 8.5 48.8672 8.5Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.2285 16.9912H60.6631C61.5316 16.9912 62.3368 17.6288 62.584 18.6162L68.2715 41.3779C68.8556 43.7138 67.2333 45.9111 65.1504 45.9111H32.7373C30.6544 45.911 29.0326 43.7142 29.6201 41.3789V41.3779L35.3086 18.6162C35.555 17.6298 36.3599 16.9912 37.2285 16.9912Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.7964 31.1219L44.6717 32.277V34.0906H43.3545V26.998H44.6717V30.6355L48.1774 26.998H49.6568L46.6779 30.1694L49.8391 34.0906H48.299L45.7964 31.1219Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.747 28.68V33.2699C55.747 35.1748 54.7743 36.1272 52.8289 36.1272C52.3088 36.1272 51.8157 36.0597 51.3496 35.9246C50.8836 35.7962 50.4985 35.6071 50.1946 35.3572L50.762 34.4047C50.9984 34.6006 51.2956 34.756 51.6536 34.8708C52.0184 34.9924 52.3865 35.0532 52.758 35.0532C53.3524 35.0532 53.7881 34.9181 54.0651 34.6479C54.342 34.3777 54.4805 33.9657 54.4805 33.4118V33.1281C54.2644 33.3645 54.0009 33.5435 53.6902 33.6651C53.3795 33.7867 53.0383 33.8475 52.6668 33.8475C52.1535 33.8475 51.6874 33.7394 51.2686 33.5232C50.8565 33.3003 50.5289 32.9896 50.2858 32.5911C50.0493 32.1925 49.9311 31.7366 49.9311 31.2232C49.9311 30.7098 50.0493 30.2573 50.2858 29.8655C50.5289 29.4669 50.8565 29.1596 51.2686 28.9434C51.6874 28.7273 52.1535 28.6192 52.6668 28.6192C53.0586 28.6192 53.4132 28.6834 53.7307 28.8117C54.055 28.9401 54.3251 29.136 54.5413 29.3994V28.68H55.747ZM52.8593 32.7734C53.3389 32.7734 53.7307 32.6316 54.0347 32.3479C54.3454 32.0574 54.5008 31.6825 54.5008 31.2232C54.5008 30.7706 54.3454 30.4025 54.0347 30.1188C53.7307 29.8351 53.3389 29.6932 52.8593 29.6932C52.373 29.6932 51.9745 29.8351 51.6637 30.1188C51.3598 30.4025 51.2078 30.7706 51.2078 31.2232C51.2078 31.6825 51.3598 32.0574 51.6637 32.3479C51.9745 32.6316 52.373 32.7734 52.8593 32.7734Z",
					fill: "#A35705"
				})
			]
		})]
	})]
});
export default SvgMass;
